import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'scProducerCodePipe' })
export class ProducerCodePipe implements PipeTransform {

    constructor() { }

    transform(producerCode: string) {
        return producerCode.substr(0,2).concat('-').concat(( '0000' + producerCode).substr(-4,4));
    }
}